import en from './locale/en';
import ru from './locale/ru';

export default {
  en,
  ru,
};
